// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body, html {\n  margin: 0;\n  height: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","file":"styles.scss","sourcesContent":["body, html {\n  margin: 0;\n  height: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}"]}]);
// Exports
module.exports = exports;
